import PercentageOfTotal from "./PercentageOfTotal";

export default PercentageOfTotal;



// WEBPACK FOOTER //
// ./src/components/Pricebook/PercentageOfTotal/index.js